import axios from "axios";

export default axios.create({
    baseURL: "https://app.ecoraapp.com:8097", //https://app.ecoraapp.com:8097 http://localhost:8090/api
    headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*"
    }
});